import { Formik } from "formik";
import Loader from "../../loader";
import StepsDots from "../../form/StepsDots";
import ErrorMessage from "../../form/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { profileStep4Schema } from "../../../utils/schema";
import { findAJobPaths } from "../../../routes/find-a-job";
import {
  setIsFindAJobModal,
  setRegisterStep,
} from "../../../redux/features/find-a-job/reducers/authReducer";
import { profileStep4Submit } from "../../../redux/features/find-a-job/actions/authAction";
import {
  getFreelancerFormData,
  clearFreelancerFormData,
  setProfile,
  updateFreelancerFormData,
} from "../../../utils/pip";

const ProfileSetupStep4 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { subLoading } = useSelector((state) => state.freelancer.auth);
  const savedData = getFreelancerFormData()?.profileStep4 || {};
  const handleStep4 = (values) => {
    const { consent_accuracy, consent_contact, ...rest } = values;
    updateFreelancerFormData("profileStep4", values);

    const allData = getFreelancerFormData() || {};
    const step1 = allData.step1 || {};
    const step1Profile = allData.profileStep1 || {};
    const step2Profile = allData.profileStep2 || {};
    const step3Profile = allData.profileStep3 || {};
    const step4Profile = { ...rest };

    const full_name = (step1.full_name || "").trim();
    const first_name = full_name;
    const last_name = "";

    const open_talent = {
      phone_number: step1Profile.phone_number || "",
      country: step1Profile.country || "",
      city: step1Profile.city || "",
      linkedin_profile: step1Profile.linkedin_profile || "",
      portfolio_website: step1Profile.portfolio_website || "",
      bio: step1Profile.bio || "",
      location:
        step1Profile.country && step1Profile.city
          ? `${step1Profile.city}, ${step1Profile.country}`
          : step1Profile.country || step1Profile.city || "",
      primary_role: step2Profile.primary_role || "",
      talent_role: step2Profile.primary_role || "",
      years_of_experience: step2Profile.years_of_experience || "",
      key_skills: (step2Profile.key_skills || []).join(","),
      tools: (step2Profile.tools || []).join(","),
      availability: step2Profile.availability || "",
      hourly_rate: step2Profile.hourly_rate || "",
      preferred_project_type: (step2Profile.preferred_project_type || []).join(","),
      experiences: step3Profile.experiences || [],
      portfolio_links: step3Profile.portfolio_links || [],
      work_samples: step3Profile.work_samples || [],
      join_reason: step4Profile.join_reason || "",
      interested_clients: step4Profile.interested_clients || "",
      heard_about: step4Profile.heard_about || "",
      talent_type: step1.talent_type || "FREELANCER",
    };

    const payload = {
      why_join_nuvio: step4Profile.join_reason || "",
      how_hear_about_nuvio: step4Profile.heard_about || "",
      clients_types: step4Profile.interested_clients || "",
      information_confirmed: !!values?.consent_accuracy,
      agree_contact_opportunities: !!values?.consent_contact,
    };

    const callback = (response) => {
      if (!response?.success) return;
      setProfile("freelancer", {
        first_name,
        last_name,
        email: step1.email || "",
        open_talent,
      });
      clearFreelancerFormData();
      localStorage.setItem("freelancer_free_trial_modal", "1");
      dispatch(setIsFindAJobModal(false));
      dispatch(setRegisterStep(1));
      navigate(findAJobPaths.Dashboard);
    };

    dispatch(profileStep4Submit({ payload, callback }));
  };

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div class="modal-body pe-0">
      <section class="ct_signup_main py-3">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
              <div class="ct_signup_left_img">
                <img
                  src="../assets/img/setp_6_freelance_img_left.png"
                  alt=""
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>
            <div class="col-xxl-8 col-xl-8 col-lg-8 mb-4 mb-lg-0 ">
              <div class="ct_signup_right_content px-5 ct_custom_scroll">
                <div class="ct_signup_logo ct_mb_34">
                  <img src="../assets/img/Nuvio_logo.png" alt="" />
                </div>
                <div class="mt-0 text-center">
                  <h2 class="ct_fs_32  mb-0 ct_darkblue_text">
                    NUVIO Network
                  </h2>
                  <p className="mb-0 ct_fs_16 mt-2 ct_darkblue_text mx-auto">
                    Help us understand your goals and how we can connect you with
                    the right clients.
                  </p>
                </div>
                <Formik
                  initialValues={{
                    join_reason: savedData?.join_reason || "",
                    interested_clients: savedData?.interested_clients || "",
                    heard_about: savedData?.heard_about || "",
                    consent_accuracy: savedData?.consent_accuracy || false,
                    consent_contact: savedData?.consent_contact || false,
                  }}
                  validationSchema={profileStep4Schema}
                  validateOnChange={true}
                  validateOnBlur={true}
                  enableReinitialize
                  onSubmit={(values, actions) => {
                    handleStep4(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setTouched,
                  }) => (
                    <form onSubmit={handleSubmit} class="ct_mt_40">
                      <div className="row">
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              Why do you want to join NUVIO?
                            </label>
                            <textarea
                              class="form-control ct_input h-auto"
                              rows={4}
                              placeholder="Share your motivation"
                              id="join_reason"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.join_reason}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName={"join_reason"}
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              What type of clients are you interested in working with?
                            </label>
                            <textarea
                              class="form-control ct_input h-auto"
                              rows={4}
                              placeholder="Describe the clients or industries you prefer"
                              id="interested_clients"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.interested_clients}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName={"interested_clients"}
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label class="mb-2 d-block ct_fs_14 ct_darkblue_text">
                              How did you hear about NUVIO?
                            </label>
                            <select
                              class="form-control ct_input"
                              id="heard_about"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={values?.heard_about}
                            >
                              <option value="">Select an option</option>
                              <option value="LinkedIn">LinkedIn</option>
                              <option value="Referral">Referral</option>
                              <option value="Website">Website</option>
                              <option value="Event / Webinar">Event / Webinar</option>
                              <option value="Other">Other</option>
                            </select>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName={"heard_about"}
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-3">
                            <label class="ct_checkbox_label d-flex gap-2">
                              <input
                                type="checkbox"
                                id="consent_accuracy"
                                checked={values.consent_accuracy}
                                onChange={handleChange}
                              />
                              <span class="ct_fs_14 ct_darkblue_text">
                                I confirm that the information provided is accurate.
                              </span>
                            </label>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="consent_accuracy"
                            />
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="form-group mb-3">
                            <label class="ct_checkbox_label d-flex gap-2">
                              <input
                                type="checkbox"
                                id="consent_contact"
                                checked={values.consent_contact}
                                onChange={handleChange}
                              />
                              <span class="ct_fs_14 ct_darkblue_text">
                                I agree to be contacted by NUVIO regarding freelance opportunities.
                              </span>
                            </label>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="consent_contact"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="text-center mt-2">
                        <button
                          type="submit"
                          onClick={handleSubmit}
                          class="ct_yellow_btn  w-100 mx-auto"
                        >
                          Continue
                        </button>
                      </div>
                      <StepsDots steps={[1, 2, 3, 4]} activeStep={4} />
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfileSetupStep4;
